// extracted by mini-css-extract-plugin
export default {"banner_box":"index_banner_box_-7x79","banner":"index_banner_TYr5e","brandImgUrl":"index_brandImgUrl_L1CJ3","brandImgLink":"index_brandImgLink_wnIWg"};